import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { ChiTietDonDialog } from 'modules/dialog';
import { get } from 'lodash';

class RowItemDanhSachDon extends React.Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      type: this.props.type,
      userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
      typeTime: '',
      value: '',
      ketQuaStr: '',
      ketQuaType: '',
      trangThaiDonText: '',
      trangThaiDonType: '',
      canBoXuLy: '',
    }
  }

  componentDidMount() {
    if (this.props.item.trangThaiDonInfo) {
      let donViDangXLGQId = this.props.item.donViXuLyGiaiQuyetInfo ? this.props.item.donViXuLyGiaiQuyetInfo.coQuanQuanLyId : '';
      this.props.item.trangThaiDonInfo.filter(item => {
        return item.donViId == donViDangXLGQId;
      }).map((child, i) => {
        if (this.props.item.ma && child.ketQuaType == 'DINH_CHI') {
          this.setState({
            ketQuaStr: 'Đình chỉ',
            ketQuaType: child.ketQuaType,
            trangThaiDonText: child.trangThaiDonText,
            trangThaiDonType: child.trangThaiDonType,
          })
        } else if (!this.props.item.ma && child.ketQuaType == 'DINH_CHI') {
          this.setState({
            ketQuaStr: 'Rút đơn',
            ketQuaType: child.ketQuaType,
            trangThaiDonText: child.trangThaiDonText,
            trangThaiDonType: child.trangThaiDonType,
          })
        } else {
          this.setState({
            ketQuaStr: child.ketQuaStr,
            ketQuaType: child.ketQuaType,
            trangThaiDonText: child.trangThaiDonText,
            trangThaiDonType: child.trangThaiDonType,
          })
        }
      })
    }
  }

  showThongTinCongDan() {
    let size = this.props.item.listNguoiDungDon.length;
    if (size) {
      return (
        <div>
          <li className="txt-bold">{this.props.item.listNguoiDungDon[0].hoVaTen}</li>
          <li>{this.getLocal(this.props.item.listNguoiDungDon[0])}</li>
          <li>{this.props.item.listNguoiDungDon[0].soDienThoai}</li>
        </div>
      )
    }
  }

  showThoiHanXuLyDon(ketQuaType = null) {
    let thoiHanXuLy = {};
    let donViDangXLGQId = this.props.item.donViXuLyGiaiQuyetInfo ? this.props.item.donViXuLyGiaiQuyetInfo.coQuanQuanLyId : '';
    if (this.checkDonViTTXM() && this.state.ketQuaType === 'DANG_LAP_DU_THAO') {
      thoiHanXuLy = this.props.item.thoiHanGiaoLapDuThaoInfo
    } else if (ketQuaType != null && ketQuaType === 'DANG_TTXM') {
      thoiHanXuLy = this.props.item.thoiHanTTXMInfo;
    } else if (this.props.item.thongTinGiaiQuyetDonInfo && this.props.item.thongTinGiaiQuyetDonInfo.ngayBatDauKTDX) {

      thoiHanXuLy = this.props.item.thoiHanKTDXInfo;
    } else {
      if (this.props.item.donViThamTraXacMinhInfo && this.props.item.donViThamTraXacMinhInfo.coQuanQuanLyId == donViDangXLGQId) {

        thoiHanXuLy = this.props.item.thoiHanTTXMInfo;
      } else {

        this.props.item.trangThaiDonInfo.filter(item => {
          return item.donViId == donViDangXLGQId;
        }).map((child, i) => {

          if (child.trangThaiDonType === 'DANG_XU_LY')
            thoiHanXuLy = this.props.item.thoiHanXuLyInfo;
          if (child.trangThaiDonType === 'DANG_GIAI_QUYET')
            thoiHanXuLy = this.props.item.thoiHanGiaiQuyetInfo;
        });
      }
    }

    if (thoiHanXuLy.type === 'DAY') {

      if (thoiHanXuLy.value == 0) {
        return (
          <p style={{ color: "#E9573F" }}>Hết hạn</p>
        )
      } else if (thoiHanXuLy.value > 0) {
        return (
          <p>Còn {thoiHanXuLy.value} ngày</p>
        )
      } else {
        return (
          <p style={{ color: "#E9573F" }}>Trễ {Math.abs(thoiHanXuLy.value)} ngày</p>
        )
      }
    } else if (thoiHanXuLy.type === 'TIME') {
      return (
        <p style={{ color: "#E9573F" }}>Còn {thoiHanXuLy.value}</p>
      )
    }
  }

  showThoiHanLapDuThao() {
    let thoiHanXuLy = this.props.item.thoiHanGiaoLapDuThaoInfo
    if (thoiHanXuLy.type == 'DAY') {

      if (thoiHanXuLy.value == 0) {
        return (
          <p style={{ color: "#E9573F" }}>Hết hạn</p>
        )
      } else if (thoiHanXuLy.value > 0) {
        return (
          <p>Còn {thoiHanXuLy.value} ngày</p>
        )
      } else {
        return (
          <p style={{ color: "#E9573F" }}>Trễ {Math.abs(thoiHanXuLy.value)} ngày</p>
        )
      }
    } else if (thoiHanXuLy.type == 'TIME') {
      return (
        <p style={{ color: "#E9573F" }}>Còn {thoiHanXuLy.value}</p>
      )
    }
  }

  checkDonViTTXM() {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    if (this.props.item.donViThamTraXacMinhInfo && this.props.item.donViThamTraXacMinhInfo.coQuanQuanLyId == userInfo.donViId) {
      return true
    } else {
      return false
    }
  }

  getLocal(data) {
    let address = [];
    if(data) {
      if(data.diaChi) {
        address.push(data.diaChi);
      }
      if(data.toThon) {
        address.push(data.toThon);
      }
      if(data.phuongXaCongDan && data.phuongXaCongDan.ten) {
        address.push(data.phuongXaCongDan.ten);
      }
      if(data.quanHuyenCongDan && data.quanHuyenCongDan.ten) {
        address.push(data.quanHuyenCongDan.ten);
      }
      if(data.tinhThanhCongDan && data.tinhThanhCongDan.ten) {
        address.push(data.tinhThanhCongDan.ten);
      }
    }
    return address.join(", ");
  }

  render() {
    let donDate = this.props.item.ngayTiepNhan ? moment(this.props.item.ngayTiepNhan).format('DD/MM/YYYY') : '';
    let donTime = this.props.item.ngayTiepNhan ? moment(this.props.item.ngayTiepNhan).format('HH:mm') : '';

    let loaiDonThu = this.props.dataLoaiDonThu.filter(state => {
      return state.giaTri == this.props.item.loaiDon
    });
    return (
      <tr>
        <td>{this.props.count}</td>
        <td>{this.props.item.maHoSo ? this.props.item.maHoSo : ''}</td>
        <td>
          <ul className="list-items-table">
            <li>{donDate}</li>
            <li>{donTime}</li>
          </ul>
        </td>
        <td>
          <ul className="list-items-table">
            {this.showThongTinCongDan()}
          </ul>
        </td>
        <td>
          <ul className="list-items-table">
            <li>
              <ChiTietDonDialog checkTDGS={true} item={this.props.item} trangThaiDonText={this.state.trangThaiDonText} hanGiaiQuyet={this.showThoiHanXuLyDon()}/>
            </li>
            <li className="list-items-table">{this.showThoiHanXuLyDon()}</li>
          </ul>
        </td>
        <td>
          { get(this.props.item, 'donViXuLyGiaiQuyetInfo.ten', '') }
        </td>
        <td>
          <ul className="list-items-table">
            <li>
              {loaiDonThu.length > 0 ? loaiDonThu[0].ten : ''}
            </li>
            <li>{this.props.item.soNguoi ? (this.props.item.soNguoi + ' người') : ''}</li>
          </ul>
        </td>
      </tr>
    );
  }
}

RowItemDanhSachDon.defaultProps = {
  dataLoaiDonThu: []
}

let bindStateToProps = state => {
  return {
    dataLoaiDonThu: state.duLieuHeThong.loaiDonThu
  }
}

export default connect(bindStateToProps)(RowItemDanhSachDon);



// WEBPACK FOOTER //
// ./src/components/modules/theo-doi-giam-sat/datatable/RowItemDanhSachDon.jsx